export default "__VITE_ASSET__DL4WR$nW__"